import React from 'react';

interface IProps {
  textValue: string;
  onChange: (newValue: number, isValid: boolean, errorMessage: string) => void;
}

const MaxFlashcardsTextbox = (props: IProps) => {
  const onChange = (event: any) => {
    const text = event.target.value;

    if (!text) {
      props.onChange(0, false, '');
      return;
    }

    let number = NaN;

    try {
      number = parseInt(text);
    } catch {
      props.onChange(0, false, 'Invalid value');
      return;
    }

    if (number <= 0) {
      props.onChange(0, false, 'Value must be greater than 0');
      return;
    }

    props.onChange(number, true, '');
  };

  return (
    <div className="form-control">
      <label className="label cursor-pointer">
        <span className="label-text text-base-content"></span>
        <input
          className="focus:shadow-outline appearance-none rounded border px-3 py-2 leading-tight text-gray-700 shadow focus:outline-none"
          id="maxFlaschards"
          autoComplete="off"
          type="number"
          placeholder={`e.g. 135`}
          value={props.textValue}
          onChange={onChange}
          autoFocus
        />
      </label>
    </div>
  );
};

export default MaxFlashcardsTextbox;
